import { Box, Typography } from "@mui/material"
import KeyboardDoubleArrowUpOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowUpOutlined"
import KeyboardDoubleArrowDownOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowDownOutlined"

type Props = {
  incidentPriorities: {
    id: number
    name: string
    color: string
    priority: number
  }[]
}

export function IncidentPriorityGradient({ incidentPriorities }: Props) {
  const colors = incidentPriorities.map(priority => priority.color).join(",")
  const gradient = `linear-gradient(to bottom, ${colors})`

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        height: "100%",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <KeyboardDoubleArrowUpOutlinedIcon
          sx={theme => ({ marginLeft: theme.spacing(-0.75) })}
        />
        <KeyboardDoubleArrowDownOutlinedIcon
          sx={theme => ({ marginLeft: theme.spacing(-0.75) })}
        />
      </Box>

      <Box
        sx={theme => ({
          height: "100%",
          minWidth: theme.spacing(1),
          background: gradient,
          borderRadius: theme.spacing(1),
        })}
      ></Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        {incidentPriorities.map(priority => (
          <Typography key={priority.id}>{priority.name}</Typography>
        ))}
      </Box>
    </Box>
  )
}